angular
  .module('VSPApp')
  .controller('FooterController', ['$scope', 'BUILD_VERSION', function ($scope, BUILD_VERSION) {
    $scope.this_year = new Date().getFullYear();
    $scope.build_version = BUILD_VERSION;
  }]);
